module.exports = __webpack_public_path__ + "img/9788975276125.377e9b15.jpg";